import { blue, green, purple, yellow } from '@mui/material/colors'

export const DRAWERWIDTH = 240

/** Default page size for debounced search autocompletes (`ApiAutoComplete`, etc.). */
export const API_AUTOCOMPLETE_PAGE_SIZE = 100

export const ATTRIBUTE_TYPES = {
  COURSE_ATTRIBUTES: 'Course Attributes',
  STUDENT_COURSE_ATTRIBUTES: 'Student Attributes',
  FACULTY_COURSE_ATTRIBUTES: 'Faculty Attributes',
  USER_COURSE_ATTRIBUTES: 'User Attributes'
} as const

// Shared chip palette for any UI that renders an attribute value as a small
// type-colored chip (AttributesMultiSelect dropdown rows, Reports scope badges).
// Keyed by the user-facing strings in ATTRIBUTE_TYPES so it lines up with the
// `attributeType` field BE returns on attribute rows.
export const ATTRIBUTE_TYPE_CHIP: Record<string, { bg: string, fg: string }> = {
  [ATTRIBUTE_TYPES.COURSE_ATTRIBUTES]: { bg: blue[100], fg: blue[700] },
  [ATTRIBUTE_TYPES.FACULTY_COURSE_ATTRIBUTES]: { bg: purple[100], fg: purple[700] },
  [ATTRIBUTE_TYPES.STUDENT_COURSE_ATTRIBUTES]: { bg: green[100], fg: green[700] },
  [ATTRIBUTE_TYPES.USER_COURSE_ATTRIBUTES]: { bg: yellow[100], fg: yellow[800] }
}

export const SISWorker = 'SIS ServiceWorker'
export const SISSync = 'SIS Sync'

export const ON_CLASSRANKED = window.location.href.includes('classranked.com')

export const READONLY_TOOLTIP = "You don't have permission to perform this action. Please contact your institution admin."
